<template>
  <v-text-field
    v-model="text"
    type='text'
    :label="label"
    :error-messages="errors"
    :hide-details="!v.$error"
    v-mask="mask"
    outlined
    dense
    :disabled="disabled"
  >
  </v-text-field>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  props: [
    'value',
    'v',
    'errors',
    'label',
    'mask',
    'disabled',
  ],

  directives: { mask },

  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/MaskedInputComponent.vue